import script from "./RequisitesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RequisitesPage.vue?vue&type=script&setup=true&lang=js"

import "./RequisitesPage.vue?vue&type=style&index=0&id=2d986a03&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d986a03"]])

export default __exports__